var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8157 6.62143C0.873205 6.98786 0.210205 7.92643 0.210205 9V24.4286C0.210205 25.8493 1.37371 27 2.8102 27H23.6102C25.0467 27 26.2102 25.8493 26.2102 24.4286V9C26.2102 7.57929 25.0467 6.42857 23.6102 6.42857H8.4067L19.1512 2.14071L18.2542 0L1.8157 6.62143ZM6.71021 24.4286C4.5587 24.4286 2.8102 22.6993 2.8102 20.5714C2.8102 18.4436 4.5587 16.7143 6.71021 16.7143C8.8617 16.7143 10.6102 18.4436 10.6102 20.5714C10.6102 22.6993 8.8617 24.4286 6.71021 24.4286ZM23.6102 14.1429H21.0102V11.5714H18.4102V14.1429H2.8102V9H23.6102V14.1429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.bd24801b807a174e2cfd07032b43ddf3.svg";
export { ForwardRef as ReactComponent };